import { FC } from "react"
import {
  View,
  ViewStyle,
  TextStyle,
  TouchableOpacity,
  Linking,
  useWindowDimensions,
} from "react-native"

import { Text } from "@/components/Text"
import { colors, spacing, breakpoints } from "@/theme"

interface FooterProps {
  style?: ViewStyle
}

const IMPRESSUM_URL = "https://www.holdeineplakette.de/impressum/"
const DATENSCHUTZ_URL = "https://www.holdeineplakette.de/datenschutzerklarung/"

export const Footer: FC<FooterProps> = ({ style }) => {
  const { width } = useWindowDimensions()
  const isMobile = width < breakpoints.mobile

  const handleLinkPress = (url: string) => {
    Linking.openURL(url)
  }

  return (
    <View style={[$container, isMobile && $containerMobile, style]}>
      <Text style={isMobile ? $copyrightTextMobile : $copyrightText} numberOfLines={1}>
        {isMobile
          ? "©HAS4 Technologies Nürnberg GmbH"
          : "©HAS4 Technologies Nürnberg GmbH. Alle Rechte vorbehalten."}
      </Text>
      <View style={$linksContainer}>
        <TouchableOpacity onPress={() => handleLinkPress(IMPRESSUM_URL)}>
          <Text style={isMobile ? $linkTextMobile : $linkText}>Impressum</Text>
        </TouchableOpacity>
        <Text style={isMobile ? $separatorMobile : $separator}>•</Text>
        <TouchableOpacity onPress={() => handleLinkPress(DATENSCHUTZ_URL)}>
          <Text style={isMobile ? $linkTextMobile : $linkText}>Datenschutz</Text>
        </TouchableOpacity>
      </View>
    </View>
  )
}

const $container: ViewStyle = {
  backgroundColor: colors.surface,
  paddingHorizontal: 20,
  paddingVertical: 12,
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  borderTopWidth: 1,
  borderTopColor: colors.footerBorder,
}

const $containerMobile: ViewStyle = {
  paddingHorizontal: 12,
  paddingVertical: 6,
}

const $copyrightText: TextStyle = {
  fontSize: 11,
  color: colors.footerText,
  flex: 1,
}

const $copyrightTextMobile: TextStyle = {
  fontSize: 9,
  color: colors.footerText,
  flex: 1,
}

const $linksContainer: ViewStyle = {
  flexDirection: "row",
  alignItems: "center",
  gap: spacing.xs,
}

const $linkText: TextStyle = {
  fontSize: 11,
  color: colors.footerText,
  textDecorationLine: "none",
  // @ts-ignore
  transition: "color 150ms ease",
}

const $linkTextMobile: TextStyle = {
  fontSize: 9,
  color: colors.footerText,
  textDecorationLine: "none",
  // @ts-ignore
  transition: "color 150ms ease",
}

const $separator: TextStyle = {
  fontSize: 11,
  color: colors.footerSeparator,
}

const $separatorMobile: TextStyle = {
  fontSize: 9,
  color: colors.footerSeparator,
}
